
export const i19z = {
  i19r: { // クライアント
    v0: {
      itlz: {
//        i19r_20r1k: -1,
//        i19r_31r1f: -1,
        i19ra1110s: '',
        i19ra1120s: '',
        i19ra1130s: '',
        i19ra1210s: '',
        i19ra1220i: -1,
        i19ra2110i: -1,
        i19ra2210i: -1,
        i19ra2310i: -1,
        i19ra2320s: '',
        i19ra2330s: '',
        i19ra2410i: -1,
        i19ra2420i: 10,
        i19ra3100j: '',
        i19ra3200j: '',
        i19ra4100i: 1,
      },
      fldz: {
/*
        i19r_20r1k: {
          pfx: 'ドメイン' 
        },
*/
/*
        i19r_31r1f: {
          pfx: '施設' 
        },
*/
        _icn: {
          pfx: `クライアントID` 
        },
        _pfx: {
          pfx: `クライアント名` 
        },
        i19ra1110s: {
          pfx: 'スタッフ用ドメイン',
        },
        i19ra1120s: {
          pfx: 'スタッフ用ログインID', 
          atrs: [ // 運営用ユーザの登録
            {
              qry: `
                INSERT INTO
                  _10rs
                (
                  _dmn,
                  _10r_31r1f,
                  _icn,
                  _pfx,
                  _10rt1100i,
                  _10ra2100s,
                  _who,
                  _dtm,
                  "createdAt",
                  "updatedAt"
                ) VALUES (
                  {i19r_dmn},
                  0,
                  '_SystemAdmin20230118_',
                  'システム運営者',
                  20,
                  '{i19ra1120s}',
                  -1,
                  now(),
                  now(),
                  now()
                )
                ON CONFLICT ON CONSTRAINT _10r_unq1
                DO UPDATE
                SET
                  _10ra2100s = '{i19ra1120s}',
                  _who = {i19r_who},
                  _dtm = now()
              `,
              rlcz: {
                i19r_dmn: 'i19rs._dmn',
                i19r_who: 'i19rs._who',
                i19ra1120s: 'i19rs.i19ra1120s',
              }
            },
          ],
        },
        i19ra1130s: {
          pfx: 'スタッフ用パスワード', 
          atrs: [
            {
              qry: `
                INSERT INTO
                  _101s
                (
                  _dmn,
                  _101_31r1f,
                  _101_10r1k,
                  _101a1100s,
                  _who,
                  _dtm,
                  "createdAt",
                  "updatedAt"
                ) VALUES (
                  {i19r_dmn},
                  0,
                  (
                    SELECT 
                      _key 
                    FROM 
                      _10rs 
                    WHERE 
                      COALESCE(_dlt,-1) <> 1
                      AND _dmn = {i19r_dmn} 
                      AND _10r_31r1f = 0 
                      AND _icn= '_SystemAdmin20230118_' 
                      AND _10rt1100i = 20 
                  ),
                  '{i19ra1130s}',
                  -1,
                  now(),
                  now(),
                  now()
                )
                ON CONFLICT ON CONSTRAINT _101_unq1
                DO UPDATE
                SET
                  _101a1100s = '{i19ra1130s}',
                  _who = {i19r_who},
                  _dtm = now()
              `,
              rlcz: {
                i19r_dmn: 'i19rs._dmn',
                i19r_who: 'i19rs._who',
                i19ra1130s: 'i19rs.i19ra1130s',
              }
            }
          ]
        },

        i19ra1210s: {
          pfx: '団体用ドメイン', 
        },
        i19ra1220i: {
          pfx: '団体用ログイン方式', 
          ls: [
            { key: 10, pfx: '団体番号＋メールアドレス' },
            { key: 20, pfx: 'ログインID' },
            { key: 30, pfx: '団体番号のみ' },
          ]
        },

        i19ra2110i: {
          pfx: 'メール配信機能', 
          ls: [
            { key: -1, pfx: `使用しない` },
            { key:  1, pfx: `使用する` },
          ]
        },
        i19ra2210i: {
          pfx: '備品・駐車場機能', 
          ls: [
            { key: -1, pfx: `使用しない` },
            { key:  1, pfx: `使用する` },
          ]
        },
        i19ra2310i: {
          pfx: '電子決済機能', 
          ls: [
            { key: -1, pfx: `使用しない` },
            { key:  1, pfx: `使用する` },
          ]
        },
        i19ra2320s: {
          pfx: '決済用公開鍵', 
        },
        i19ra2330s: {
          pfx: '決済用秘密鍵', 
        },
        i19ra2410i: {
          pfx: '外部連携機能', 
          ls: [
            { key: -1, pfx: `使用しない` },
            { key:  1, pfx: `使用する` },
          ]
        },
        i19ra2420i: {
          pfx: '外部連携公開区分', 
          ls: [
            { key: 10, pfx: `非公開` },
            { key: 20, pfx: `申込団体を表示` },
            { key: 30, pfx: `目的を表示` },
          ]
        },
        i19ra3100j: {
          pfx: '団体情報の非表示項目', 
          ls: [
            { key: 110, pfx: 'メール１' },
            { key: 120, pfx: 'メール２' },
            { key: 130, pfx: 'メール３' },
            { key: 210, pfx: '会員構成/男性' },
            { key: 220, pfx: '会員構成/女性' },
            { key: 230, pfx: '会員構成/大人' },
            { key: 240, pfx: '会員構成/こども' },
            { key: 310, pfx: '指導者名' },
            { key: 320, pfx: '連絡先名' },
          ],
        },
        i19ra3200j: {
          pfx: '団体情報の必須項目', 
          ls: [
            { key: 110, pfx: '郵便番号' },
            { key: 120, pfx: '都道府県' },
            { key: 130, pfx: '市区町番地' },
            { key: 210, pfx: '電話１' },
            { key: 310, pfx: 'ジャンル' },
            { key: 320, pfx: '活動内容' },
            { key: 410, pfx: '会員募集' },
          ],
        },
        i19ra4100i: {
          pfx: '抽選間隔', 
          ls: [
            { key: 1, pfx: '1カ月' },
            { key: 3, pfx: '3カ月' }, // 泉寿荘
          ],
        },
        i19ra4200i: {
          pfx: 'エントリー基準月', 
          ls: [
            { key: 1, pfx: '1月' },
            { key: 2, pfx: '2月' },
            { key: 3, pfx: '3月' },
          ],
        },
      },
    },
  },
  i191: { // 施設
    v0: {
      itlz: {
        i191_31r1k: -1,
        i191a1100s: '',
        i191a2100s: '',
        i191a3100s: '',
      },
      fldz: { // i191i19r1k はなし
        i191_31r1k: { // _fst でなく _key
          pfx: '施設' 
        },
        i191a1100s: {
          pfx: `施設URL`, 
        },
        i191a2100s: { // 廃止予定
          pfx: '外部連携ログインID' 
        },
        i191a3100s: { // 廃止予定
          pfx: '外部連携パスワード' 
        },
        i191a4110s: {
          pfx: 'メールアドレス' 
        },
        i191a4120s: {
          pfx: 'メールパスワード' 
        },
        i191a5110i: { // 廃止予定
          pfx: '開始時刻' 
        },
        i191a5120i: { // 廃止予定
          pfx: '終了時刻' 
        },
      }
    }
  },
  i192: { // 時間外連携データ  履歴対象外
    v0: {
      itlz: {
        i192_31r1k: -1,
        i192d1100s: '',
        i192a1100s: '',
      },
      fldz: { // i191i19r1k はなし
        i192_31r1f: { // _key でなく _fst
          pfx: '施設' 
        },
        i192d1100s: {
          pfx: `連携日`, 
        },
        i192a1110t: {
          pfx: '開始連携ID（json形式）' 
        },
        i192a1120t: {
          pfx: '終了連携ID（json形式）' 
        },
      }
    }
  },
};
